import { Navigate, type RouteObject } from "react-router-dom";
import { AppLayout } from "./AppLayout";
import { RouteError } from "./ErrorBoundary";
import { RequireAuth } from "./RequireAuth";
import { SignIn } from "./SignIn";
import { NotFound } from "./NotFound";
import { routes as attendance } from "../features/attendance/routes";
import { routes as billing } from "../features/billing/routes";
import { routes as classes } from "../features/classes/routes";
import { routes as dues } from "../features/dues/routes";
import { routes as expenses } from "../features/expenses/routes";
import { routes as followups } from "../features/followups/routes";
import { routes as home } from "../features/home/routes";
import { routes as inbox } from "../features/inbox/routes";
import { routes as more } from "../features/more/routes";
import { HomeSwitch } from "../features/home/mobile/HomeSwitch";
import { routes as kiosk } from "../features/kiosk/routes";
import { routes as leads } from "../features/leads/routes";
import { routes as members } from "../features/members/routes";
import { routes as payroll } from "../features/payroll/routes";
import { routes as reports } from "../features/reports/routes";
import { routes as settings } from "../features/settings/routes";
import { routes as staff } from "../features/staff/routes";

/**
 * Written once by app-shell-home. Each area imports exactly once; a later slice fills its own folder and never edits this file.
 */
export const appRoutes: RouteObject[] = [
  { path: "/signin", element: <SignIn /> },
  {
    element: <RequireAuth />,
    errorElement: <RouteError />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { index: true, element: <Navigate to="/home" replace /> },
          ...home.map((r) => (r.path === "home" ? { ...r, element: <HomeSwitch /> } : r)), ...inbox, ...more, ...members, ...attendance, ...billing, ...dues, ...leads, ...followups, ...classes, ...staff, ...payroll, ...expenses, ...reports, ...settings, ...kiosk,
          { path: "*", element: <NotFound /> },
        ],
      },
    ],
  },
];
